export default __webpack_public_path__ + "static/media/Carolina.b7ab1215.mp4";